// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2qtdz","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3njIw","obliqueLine":"membershipbadge_obliqueLine__3dh68"};